// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
\$font-regular: 400;
\$font-medium: 500;
\$font-semiBold: 600;
\$font-bold: 700;
\$font-extraBold: 800;
\$font-black: 900;

\$mainBg: #F5F6FA;
\$primary-color: #205440;
\$icon-bgcolor: #F6F6F6;
\$text-graycolor: #727272;
\$cardIcon1-bg: #F3F4F8;
\$cardIcon2-bg: #FAF4FB;
\$cardIcon3-bg: #FAF7F3;
\$cardIcon4-bg: #F5F9FC;
\$cardIcon2-color: #AC44BB;
\$cardIcon3-color: #D69A5F;
\$cardIcon4-color: #176CA5;
\$green-color: #38A169;
\$darkGreen-color: #207a4a;
\$placeholder-color: #666666;
\$profile-dark-text: #181818;
\$heading : #0B0D0F;
\$light-gray : #999999;
\$menu_icon : #CBCBCB;
\$red-color : #F94747;



\$darkTheme_blue : #132337;
\$darkTheme_darkBlue : #0f1824;
\$darkTheme_selectBlue : #1c2e45;
\$darkTheme_updateBtn : #0a2574;

/* 
Body Theme Color
 */
\$lightthemecolor: #f3f6f9;
\$darkthemecolor: #151521;

\$white-color: #fff;
\$black-color: #1d1d1d;
\$fullBlack-color: #1d1d1d;
\$lightthemetext: #60677e;

/* 
Dark Theme Colors
*/
\$primarydark-color: #1e1e2d;

/* 
Button Theme
*/
\$primary-btncolor: #205440;
\$secondary-btncolor: rgba(37, 105, 109, 0.864);

\$tableheadlightbg: #e9eaf0;


/* 
Max Dashboard scss
*/
\$dashboardwidth: calc(100% - 320px);
\$dashboardposition: absolute;
\$dashboardleft: 290px;
\$dashboardpadding: 30px;

/* 
Min Dashboard scss
*/
\$dashwidth: calc(100% - 50px);
\$dashleft: 50px;

/* 
Max Dashboard scss
*/

.dashboard {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}
.dashboardContain { 
  width: calc(100% - 320px);
  background-Color:\$mainBg;
  border-radius: 8px;
}
.bodythemedark .dashboardContain,
.bodythemedark .dashboard, 
.bodythemedark .cont2 { 
  background-Color: \$darkTheme_darkBlue;
}
.top_header .top_header_inner {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/

.cont2 {
  width: \$dashwidth;
  left: \$dashleft;
  position: relative;
  padding: \$dashboardpadding;
  border-radius: 8px;
  background: \$mainBg;
  /* 
background-Color: \$dashboardbackgroundColor;
  padding-bottom: 8%;
*/
}

.subLink svg {
  position: relative;
  top: -2px;
  left: -7px;
}



.footer {
  height: 70px;
}

body {
  background-color: \$white-color;
}

/* 
THEME CHANGE
*/
.bodythemelight {
  background-color: \$white-color;
  padding-top: 90px;
}
.bodythemedark {
  background-color: \$darkTheme_blue;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.headerthemelight {
  background-color: \$white-color;
}

.headerthemedark {
  background-color: \$darkTheme_blue;
}
.top_header {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1; 
}

/* 
LEFT MENU THEME CHANGE
*/
.menuthemelight {
  background-color: \$white-color;
}
.menuthemedark {
  background-color: \$darkTheme_blue;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.menulinklight span {
  color: \$placeholder-color !important;
}

.menulinklight a {
  color: \$menu_icon !important;
}

.menulinklight:hover span, .menulinklight:hover a { 
  color: \$white-color !important;
}

.menulinkdarkSelected {
  background-color: \$darkTheme_selectBlue;
  color: \$white-color;
}
.menuthemelight .menulinklightSelected {
  /*background-color: \$lightthemecolor;*/
  color: \$white-color !important;
  background-color: \$primary-color;
}

.menulinkdark {
  color: \$lightthemetext !important;
}

.menulinklight:hover {
  color: \$white-color !important;
  background-color: \$primary-color;
}

.menulinkdark:hover {
  background-color: \$darkTheme_selectBlue;
  color: \$white-color;
}

/* 
BODY HEADERS
*/
.headinglight {
  color: \$lightthemetext;
}

.headingdark {
  color: \$lightthemetext;
}

/* 
SEARCH BOX THEME COLOR
*/
.searchboxlight {
  background-color: \$white-color;
  border: none;
}

.searchboxdark {
  background-color: \$darkTheme_blue;
  color: \$white-color;
  border: none;
}
.searchboxdark::placeholder {
  color: \$lightthemetext;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.tableheadlight {
  background-color: \$primary-color;
  border-radius: 5px 5px 0px 0px;
}
.tableheadlight th {
  color: \$white-color;
}
thead .tableheadlight th:first-child,
thead .tableheaddark th:first-child {
  border-radius: 5px 0 0 0px;
} 
thead .tableheadlight th:last-child,
thead .tableheaddark th:last-child  {
  border-radius: 0 5px 0px 0;
}
th:first-child {
  border-radius: 0px;
} 
td:last-child {
  border-radius: 0px;
}
table.table.table-borderless{
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.tableheaddark {
  background-color: \$primarydark-color;
  color: \$white-color;
}
.table-borderless tr:nth-child(even) {
  background-color: #F9FAFB;
}
.table-borderless .left-section {
  padding-top: 10px;
}
.tablebodylight td, 
.tablebodydark td {
  padding: 1rem 1rem !important;
}
.tablebodylight {
  background-color: \$white-color;

  &:hover {
    background-color: #ddecf9;
    cursor: pointer;
  }
}
.tablebodydark {
 /* background-color: \$primarydark-color; */
  color: \$lightthemetext;

  &:hover {
    background-color: rgba(33, 150, 243, 0.1);
    cursor: pointer;
  }
}

/* 
PAGINATION THEME COLOR
*/
.paginationlight {
  color: \$lightthemetext !important;
  font-size: 13px !important;
}
.paginationdark {
  color: \$lightthemetext !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.formthemelight {
  background-color: \$white-color;
  color: \$black-color !important;
  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);
}
.formthemedark {
  background-color: \$primarydark-color;
  color: \$lightthemetext !important;
  font-size: 14px;

  ::placeholder {
    color: \$lightthemetext;
  }
}


/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.viewformlight {
  background-color: \$lightthemecolor;
}

.permissionboxlight {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}
.permissionboxdark {
  background-color: #151521;
  border: solid 1px #242434;
}

.errormsgclr {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.graphclrlight {
  background-color: \$white-color;
}

.graphclrdark {
  background-color: \$primarydark-color;
}


/* 
Counter theme
*/
#card1bglight {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: \$white-color;
}
#card1bglight:hover {
  background: #f7fffc;
}
#card1bgdark {
  background: #392f28;
}
#card1bgdark:hover {
  background: #f7fffc;
}
#card2bglight {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: \$white-color;
}
#card2bglight:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}
#card2bgdark {
  background: #1c3238;
}

#card3bglight {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: \$white-color;
}
#card3bglight:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#card3bgdark {
  background: #3a2434;
}

#card4bglight {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: \$white-color;
}
#card4bglight:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}
#card4bgdark {
  background: #2f264f;
}

#card1bgdark a, #card1bgdark p,
#card2bgdark a , #card2bgdark p,
#card3bgdark a, #card3bgdark p,
#card4bgdark a, #card4bgdark p {
  color: \$white-color;
}

/* 
Action button theme
*/
.actionbtnlight {
  color: #46475bde;
}

.actionbtndark {
  color: \$lightthemetext;
}


/* 
profile dropdowntheme
*/
.profiledropdownlight {
  background-color: #fff;
}

.profiledropdowndark {
  background-color: #151521;
}

.settingsection #addform.formthemedark .savebtn {
  background-color: \$darkTheme_updateBtn;
  color: \$white-color;
}
#addform.formthemedark .savebtn {
  background-color: \$darkTheme_updateBtn;
  color: \$white-color;
}

.profile_conatiner {
  border-radius: 5px !important; 
}

.bodythemedark .ag-theme-alpine .ag-row {
  background: #000 !important;
}

.bodythemedark .formbtn {
  background-color: \$darkTheme_updateBtn;
}

.bodythemedark .resetbtn {
  color: \$white-color;
  background-color: transparent;
  border: solid 1px \$darkTheme_updateBtn;
}

.bodythemedark .resetbtn:hover {
  background-color: \$darkTheme_updateBtn;
}


.headingdark span {
  background-color: \$darkTheme_blue;
}

.resetbtn {
  font-size: 16px;
  font-weight: \$font-semiBold;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px \$primary-color;
  color:  \$primary-color;
  min-width: 113px;
}
.resetbtn:hover, 
.resetbtn:active, 
.resetbtn:focus {
  background-color: \$primary-color;
  color: \$white-color;
}

.addBtn {
  min-width: 140px;
  height: 44px;
  color: \$white-color;
  background-color: \$green-color;
  border: none;
  font-size: 16px;
  font-weight: \$font-semiBold;
}

.addBtn svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.addBtn:hover {
  color: \$white-color;
  background-color: \$green-color;
  border: none;
}

.cust_addBtn.addBtn svg {
  top: 2px;
}

.deleteBtn {
  min-width: auto;
padding: 10px 0;
  background-color: \$red-color;
  color: \$white-color;
  font-size: 16px;
  font-weight: \$font-semiBold;
  border: none;
}

.deleteBtn {
  min-width: auto !important;
  height: 50px !important;
  background-color: \$primary-color !important;
  color: \$white-color !important;
  font-size: 16px !important;
  font-weight: \$font-semiBold !important;
  border: none !important;
  padding: .375rem 1rem !important;
}

.deleteBtn:active, .deleteBtn:focus {
  background-color: \$red-color !important;
  color: \$white-color !important; 
  box-shadow: none !important;
}

.deleteBtn svg {
  position: relative;
  top: -2px;
}

.deleteBtn:hover, 
.deleteBtn:active, 
.deleteBtn:focus {
  background-color: \$primary-color !important;
  color: \$white-color;
  border: none;
}

.confirmBtn {
  background-color: \$primary-color;
}

.confirmBtn:hover, 
.confirmBtn:active, 
.confirmBtn:focus {
  background-color: \$primary-color;
}

.confirmBtn svg {
  top: 0;
}


.back_dlt{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.delPopContainer .modal-body {
  padding: 25px;
  text-align: center;
}

.delPopContainer .delet_icon {
  margin-bottom: 11px;
}

.delPopContainer p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.arrowback svg{
  fill: #000; 
}

.bodythemedark .arrowback {
  background-color: \$darkTheme_updateBtn; 
  color: \$white-color;
}

.bodythemedark .arrowback svg {
  fill: \$white-color;
}

.bodythemedark .drpdwn_btn {
  background-color: \$darkTheme_blue;
}

.bodythemedark .empname {
  color: \$lightthemetext !important;
}

.bodythemedark .navitemli a {
  background-color: transparent;
  border: solid 1px \$darkTheme_updateBtn;
  color: \$white-color;
}

.bodythemedark .tabnavli a.settingsgeneral, 
.bodythemedark .tabnavli a.settingslinks:hover {
  background-color: \$darkTheme_updateBtn;
  color: \$white-color;
}
.bodythemedark .tabnavli a.settingslinks {
  background-color: transparent;
  border: solid 1px \$darkTheme_updateBtn;
  color: \$white-color;
}


@media only screen and (max-width: 1200px) {
  .tableheadlight th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) { 
  .dashboard {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) { 
  #dashboardcont2{
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) { 
  .sectionright{
    float: unset !important;
  }
  .dashboard {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .cont2 {
    width: \$dashwidth !important;
    left: \$dashleft !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .bodythemelight, .bodythemedark {
    padding-top: 165px;
  }
}

@media (min-width: 576px) {
  .exer_modal_contain .modal-dialog {
      max-width: 1055px;
  }
  .delPopContainer .modal-dialog {
      max-width: 350px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE;AACF,kBAAkB;AAClB,iBAAiB;AACjB,mBAAmB;AACnB,eAAe;AACf,oBAAoB;AACpB,gBAAgB;;AAEhB,gBAAgB;AAChB,uBAAuB;AACvB,sBAAsB;AACtB,wBAAwB;AACxB,sBAAsB;AACtB,sBAAsB;AACtB,sBAAsB;AACtB,sBAAsB;AACtB,yBAAyB;AACzB,yBAAyB;AACzB,yBAAyB;AACzB,qBAAqB;AACrB,yBAAyB;AACzB,2BAA2B;AAC3B,2BAA2B;AAC3B,kBAAkB;AAClB,qBAAqB;AACrB,oBAAoB;AACpB,oBAAoB;;;;AAIpB,yBAAyB;AACzB,6BAA6B;AAC7B,+BAA+B;AAC/B,8BAA8B;;AAE9B;;EAEE;AACF,yBAAyB;AACzB,wBAAwB;;AAExB,kBAAkB;AAClB,qBAAqB;AACrB,yBAAyB;AACzB,wBAAwB;;AAExB;;CAEC;AACD,2BAA2B;;AAE3B;;CAEC;AACD,0BAA0B;AAC1B,8CAA8C;;AAE9C,0BAA0B;;;AAG1B;;CAEC;AACD,mCAAmC;AACnC,4BAA4B;AAC5B,qBAAqB;AACrB,uBAAuB;;AAEvB;;CAEC;AACD,6BAA6B;AAC7B,eAAe;;AAEf;;CAEC;;AAED;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;;EAGE,qCAAqC;AACvC;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;CAEC;;AAED;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB;;;CAGD;AACD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;;;AAIA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;CAEC;AACD;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;CAEC;AACD;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;;CAEC;AACD;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;;AAEA;;CAEC;AACD;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;CAEC;AACD;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;CAEC;AACD;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;;AAEA;;CAEC;AACD;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;;EAE9B;IACE,yBAAyB;IACzB,eAAe;EACjB;AACF;AACA;CACC,0CAA0C;EACzC,sBAAsB;;EAEtB;IACE,yCAAyC;IACzC,eAAe;EACjB;AACF;;AAEA;;CAEC;AACD;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;;CAEC;AACD;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,iDAAiD;AACnD;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;;EAEf;IACE,sBAAsB;EACxB;AACF;;;AAGA;;CAEC;AACD;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;;CAEC;AACD;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;;CAEC;AACD;EACE,iGAAiG;EACjG,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gGAAgG;EAChG,8BAA8B;AAChC;AACA;EACE,gGAAgG;EAChG,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gGAAgG;EAChG,8BAA8B;AAChC;AACA;EACE,gGAAgG;EAChG,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gGAAgG;EAChG,8BAA8B;AAChC;AACA;EACE,gGAAgG;EAChG,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;CAEC;AACD;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;;CAEC;AACD;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;;AAGA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;;EAGE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB,eAAe;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2CAA2C;EAC3C,8BAA8B;EAC9B,0BAA0B;EAC1B,sCAAsC;EACtC,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;EAGE,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,MAAM;AACR;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;EAEE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,mBAAmB;AACrB;;;AAGA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,mCAAmC;IACnC,qBAAqB;IACrB,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;MACI,iBAAiB;EACrB;EACA;MACI,gBAAgB;EACpB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
